import React, { useState, createContext, useContext, useMemo } from 'react';

const QuoteVisibilityContext = createContext(null);

export function QuoteVisibilityProvider({ children }) {
  const [isQuoteVisible, setIsQuoteVisible] = useState(false);

  const contextValue = useMemo(() => {
    function toggleQuote(action) {
      switch (action) {
        case 'open':
          setIsQuoteVisible(true);
          break;
        case 'close':
          setIsQuoteVisible(false);
          break;
        default:
          setIsQuoteVisible(state => !state);
          break;
      }
    }

    return { toggleQuote, isQuoteVisible };
  }, [isQuoteVisible]);

  return <QuoteVisibilityContext.Provider value={contextValue}>{children}</QuoteVisibilityContext.Provider>;
}

export function useQuoteVisibility() {
  return useContext(QuoteVisibilityContext);
}
